import React from 'react';
import { Link } from 'react-router-dom';
import { Media, Row, Container } from 'reactstrap';

export default function SingleSiteAdmin(props) {
  const { siteAdmin, removeSiteAdmin, canRemove } = props;

  const fullName = siteAdmin.firstName + ' ' + siteAdmin.lastName;
  const email = 'mailto:' + siteAdmin.email;

  const removeClicked = async (e) => {
    e.preventDefault();

    if (canRemove) {
      removeSiteAdmin(siteAdmin.id);
    }
  };

  return (
    <Media className="align-items-center mt-3">
      <div className="avatar avatar-55xl">
        <img className="img-thumbnail img-fluid rounded-circle mb-3 shadow-sm" src={siteAdmin.photo} alt={fullName} />
      </div>
      <div className="media-body ml-2">
        <h6 className="mb-0">
          <Container>
            <Row><Link to={'/users/edit/' + siteAdmin.id} className="fs-0">{fullName}</Link></Row>
            <Row><a className="text-700" href={email}>{siteAdmin.email}</a></Row>
            {canRemove && <Row><a href="#!" onClick={removeClicked} className="btn btn-outline-danger rounded-capsule btn-sm mt-2 py-0">Remove</a></Row>}
          </Container>
        </h6>
      </div>
    </Media>
  );
}
